module.exports = __webpack_public_path__ + "img/reviewed-docs-vector.9cf74cb2.svg";